import React, { useEffect, useRef } from 'react'
import useContent from '../../utils/content'
import { useDataQuery } from '../../hooks/useDataQuery'

// eslint-disable-next-line react/prefer-stateless-function
const Video = () => {
  const content = useContent(useDataQuery())
  const videoContainerRef = useRef()
  const playerRef = useRef()

  useEffect(() => {
    window.addEventListener('scroll', () => {
      function isInViewport(element) {
        const rect = element.getBoundingClientRect()

        if (rect.width / rect.height > window.innerWidth / window.innerHeight) {
          return (
            rect.top >= 0 &&
            rect.bottom <=
              (window.innerHeight || document.documentElement.clientHeight)
          )
        }

        return (
          rect.top <= 0 &&
          rect.bottom >=
            (window.innerHeight || document.documentElement.clientHeight)
        )
      }

      const videoContainer = videoContainerRef.current

      if (isInViewport(videoContainer)) {
        playerRef.current.play()
      } else {
        playerRef.current.pause()
      }
    })
  }, [])

  return content.videoLink ? (
    <section ref={videoContainerRef} className="video-container">
      <video
        className="video"
        playsInline
        muted
        controls
        loop
        src={content.videoLink}
        poster={content.videoPosterIos}
        ref={playerRef}
      />
    </section>
  ) : null
}

export default Video
